import {  Button, Card, Table, Space } from "antd";
import InvoiceHeader from "../../../../../../../../components/InvoiceHeader/InvoiceHeader";
import { useStateGlobalContext } from "../../../../../../../../contexts/GlobalContext";
import { NumberFormatter } from "../../../../../../../../utils/validator";
import InvoiceFooter from "../../InvoiceFooter/InvoiceFooter";
import PrintDrawer from "../../../../../../../../components/GlobalComponents/PrintDrawer";
import { useGlobalPDF } from "../../../../../../../../utils/pdfUtils";
import { InvoiceBar } from "../../../../../../../../components/GlobalComponents/GlobalComponents";
import { generateProductInvoicePDF } from "../DownloadProductInvoice";
import Notification from "../../../../../../../../components/Notification/Notification";
    
const coloumn = [
  {
    key: 1,
    title: "#",
    align: "center",
    render: (_, record, index) => index + 1,
  },
  {
    key: 2,
    title: "Sale Item",
    align: "center",
    dataIndex: "items",
  },
  {
    key: 3,
    title: "QTY",
    align: "center",
    dataIndex: "quantity",
  },
  {
    key: 4,
    title: "Unit Price",
    align: "center",
    dataIndex: "unit_price",
    render:(text)=> <NumberFormatter value={text}/>
  },
  {
    key: 5,
    title: "Total Price",
    align: "center",
    dataIndex: "price",
    render:(text)=> <NumberFormatter value={text}/>
  },
];


const PrescriptionPad = ({ visible, onClose, rxData }) => {
  const {
    officeSetting,
    patientBasicInfo,
    billingInformation,
  } = useStateGlobalContext();


  const { targetRef, downloadPDF } = useGlobalPDF(
    `${rxData?.invoice_id}.pdf` || "Invoice.pdf"
  );

  const handleDownloadProductPDF = async () => {
    try {
      await generateProductInvoicePDF(rxData, patientBasicInfo, officeSetting);
      Notification.success("Product Invoice PDF downloaded successfully!");
    } catch (error) {
      console.error("Error generating Product Invoice PDF:", error);
      Notification.error("Failed to generate Product Invoice PDF");
    }
  };

 

  return (

      <PrintDrawer title={rxData?.patient_name} visible={visible} onClose={onClose}>
      <div className="invoices-print">

        <div className="invoice-container">
          <Space className="mb-2">
            <Button onClick={downloadPDF} type="primary">
              Download Print View PDF
            </Button>
            <Button onClick={handleDownloadProductPDF} type="primary">
              Download Product Invoice PDF
            </Button>
          </Space>
          <Card className="invoice-content" ref={targetRef}>
          <InvoiceBar invoice={rxData}/>
            <InvoiceHeader
              officeInformation={officeSetting}
              patientInformation={patientBasicInfo}
              rxData={rxData}
              billingInformation={billingInformation}
            />
            <Card>
            <Table
              size="small"
              columns={coloumn}
              pagination={false}
              dataSource={rxData?.product_details}
            />
            </Card>
              <InvoiceFooter subTotal={rxData?.price} discount={rxData?.discount} discountAmount={rxData?.discounted_amount} tax={rxData?.tax} grandTotal={rxData?.total_price}/>
          </Card>
        </div>
      </div>
      </PrintDrawer>
  );
};

export default PrescriptionPad;
